/**
 * In development only: unregister all service workers and remove Workbox-related
 * cache storages. Stale PWAs (another Vite app, an old build, or cached API routes
 * on the same origin) otherwise intercept fetches and return HTML for JS/CSS, which
 * breaks the dev server and cross-origin API calls.
 */
export async function devServiceWorkerCleanup(): Promise<void> {
  if (process.env.NODE_ENV !== 'development') return;
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return;

  const registrations = await navigator.serviceWorker.getRegistrations();
  await Promise.all(registrations.map((r) => r.unregister()));

  if (typeof caches === 'undefined') return;

  const keys = await caches.keys();
  const stale = keys.filter((key) =>
    /workbox|precache|api-runtime-cache|pwa-cache/i.test(key)
  );
  await Promise.all(stale.map((key) => caches.delete(key)));
}
